import mapMetaData from "./mapMetaData";

const mapLandings = landings =>{
    return landings.map(company => {
        const { logo,nombre,pais: paisLanding,url } = company;
        const pais = paisLanding.idPais.toLowerCase();
        const id = url.split('/').pop();

        return {
            url: `${process.env.Domain}.${pais}${url}`,
            name: nombre,
            logo: logo[0].url,
            country: pais,
            newCMS:true,
            id
        }
    })
};

const getCompaniesByLetter = companiesByLetter => {
    return companiesByLetter.map(companies => {
        const { letraInicial,landings } = companies;

        return {
            landings: mapLandings(landings),
            letter: letraInicial.toUpperCase(),
        }
    })
}

export const  mapCompanies = data => {
    if(!data || Object.keys(data).length === 0 || data?.empresas?.length == 0) return null;
  
    const { empresas,landingPorLetraInicials } = data;   
    return{
        metadata:mapMetaData(empresas[0].metadata),
        companies:getCompaniesByLetter(landingPorLetraInicials)
    }
}

const mapMetaDataCompanies = ( dataN2,dataStrapi ) =>{
    const { metadata } = dataStrapi || dataN2;
    
    return metadata;
}

export const getMetadataCompanies = ( dataN2,dataStrapi ) =>{
    return{
        metadata:mapMetaDataCompanies(dataN2,dataStrapi)
    }
};

export const joinCompanies = async( dataN2,dataStrapi ) =>{

    const removeFromArray =(arr,value) =>{
        return arr.filter((ele)=>{ 
            return ele != value; 
        });
    }

    const mergeLists = (list1, list2) => {
        const allLandings = [...list1, ...list2];
        let result = [];
        allLandings.forEach((landing) => {
            const found = result.find(x => x.id == landing.id && x.country == landing.country);
            
            if (!found) {
                result.push(landing);
            } else {
                if (landing.newCMS) {
                    result = removeFromArray(result, found);
                    result.push(landing);
                }
            }
        });
    
        return result.sort(function(a, b) {
            const nameA = a.name.toUpperCase();
            const nameB = b.name.toUpperCase();

            if (nameA > nameB) {
                return 1;
            }
            if (nameA < nameB) {
                return -1;
            }
            return 0;
        });
    }
    
    const all = [...dataStrapi, ...dataN2];
    let result = [];

    all.forEach(letter => {
        const found = result.find(x => x.letter == letter.letter);
    
        if (!found) {
            result.push(letter);
        } else {
            const definitiveLetter = {
                landings:mergeLists(letter.landings, found.landings),
                letter:letter.letter
            }; 

            result = removeFromArray(result,found);
            result.push(definitiveLetter);
        } 
    });

    return result.sort(function(a, b) {
        const letterA = a.letter.toUpperCase();
        const letterB = b.letter.toUpperCase();
        if (letterA > letterB) {
            return 1;
        }
        if (letterA < letterB) {
            return -1;
        }
        return 0;
    });
};